import useAppToast from '@/hooks/useAppToast';
import { getDeleteClinicList } from '@/services/admin/deleteClinicService';
import type { DeleteClinicListQuery } from '@/types/admin-delete-clinic';
import { getApiErrorMessage, DEFAULT_FETCH_ERROR_MESSAGE } from '@/utils/apiError';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

export const useAdminDeleteClinicList = (query: DeleteClinicListQuery) => {
  const { site } = useParams<{ site: string }>();
  const currentSite = site ?? 'medix';
  const toast = useAppToast();

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['delete-clinics', currentSite, query],
    queryFn: () => getDeleteClinicList(currentSite, query),
    enabled: !!currentSite,
    staleTime: 0,
  });

  useEffect(() => {
    if (isError && error) {
      toast.error(getApiErrorMessage(error, DEFAULT_FETCH_ERROR_MESSAGE));
    }
  }, [isError, error, toast]);

  return { data, isLoading, isError, refetch, error };
};
